<template>
    <div class="mt-2">
        <div v-if="levelHasVisibleParent && categories && categories.length" class="mb-1">Filtrera på {{categories[0].parent.name}}</div>
        <v-chip
            v-for="cat in categories" :key="cat.id"
            :outlined="!cat.selected"
            color="primary"
            :close="cat.selected"
            @click="select(cat)"
            @click:close="select(cat)"
            :ripple="false"
            label
            class="mr-2 mb-2"
        >
            {{cat.name}}
        </v-chip>
    </div>
</template>

<script>
export default {
    name: 'zoezi-webshop-categories-level',

    props: {
        levelHasVisibleParent: {
        },
        categories: {
        }
    },

    methods: {
        select(cat) {
            this.$emit('selected', cat);
        }
    }
}
</script>
